export default {
    IDOSO: 1,
    GESTANTE: 2,
    PESSOA_COM_CRIANCA_DE_COLO: 3,
    PESSOA_COM_DEFICIENCIA: 4,
    PESSOA_COM_TEA: 5,
    PESSOA_COM_MOBILIDADE_REDUZIDA: 6,
    ACOMPANHANTE: 7,
    LACTANTE: 8,
    DOADOR_DE_SANGUE: 9,
}